import type { DealerStore } from "~/components/ecommerce/types/DealerStore";

export function parseTimeString(timeStr: string): { hours: number; minutes: number } {
	const [hours, minutes] = timeStr.split(".").map(Number);
	return { hours, minutes };
}

export function getOpeningHoursForDate(
	store: DealerStore,
	date: Date,
): { openingTime: string; closingTime: string } | null {
	const day = date.getDay(); // 0 = Sunday, 6 = Saturday
	if (day === 0) return null;
	if (day === 6) return store.openingHours.saturday;
	return store.openingHours.weekDays;
}

function formatTimeWithOffset(hours: number, minutes: number, offsetMinutes: number): string {
	const totalMinutes = hours * 60 + minutes + offsetMinutes;
	const resultHours = Math.floor(totalMinutes / 60);
	const resultMinutes = totalMinutes % 60;
	return `${String(resultHours).padStart(2, "0")}.${String(resultMinutes).padStart(2, "0")}`;
}

export function getNextAvailablePickupMessage(store: DealerStore, currentDate: Date): string {
	const nextDate = new Date(currentDate);
	for (let i = 1; i <= 7; i++) {
		nextDate.setDate(currentDate.getDate() + i);
		const hours = getOpeningHoursForDate(store, nextDate);
		if (hours) {
			const { hours: openHour, minutes: openMin } = parseTimeString(hours.openingTime);
			const pickupTime = formatTimeWithOffset(openHour, openMin, 30); // 30 min after opening
			const weekday = nextDate.toLocaleDateString("nb-NO", { weekday: "long" });
			return `Hent fra kl ${pickupTime} på ${weekday}`;
		}
	}
	return "Ingen tilgjengelig hentetid";
}

export function generateMessageToDisplay(store: DealerStore, now: Date = new Date()): string {
	const todayHours = getOpeningHoursForDate(store, now);
	if (!todayHours) return getNextAvailablePickupMessage(store, now); // closed today

	const { hours: openHour, minutes: openMin } = parseTimeString(todayHours.openingTime);
	const { hours: closeHour, minutes: closeMin } = parseTimeString(todayHours.closingTime);

	const openingTimeToday = new Date(now);
	openingTimeToday.setHours(openHour, openMin, 0, 0);

	const closingTimeToday = new Date(now);
	closingTimeToday.setHours(closeHour, closeMin, 0, 0);

	const lastPickupTimeToday = new Date(closingTimeToday.getTime() - 30 * 60 * 1000); // 30 min before closing

	if (now < openingTimeToday) {
		// Before opening → allow pickup today from 30 min after opening
		const pickupTime = formatTimeWithOffset(openHour, openMin, 30);
		return `Hent fra kl ${pickupTime}`;
	}

	if (now >= openingTimeToday && now <= lastPickupTimeToday) {
		// During open hours and at least 30 min before close
		return "Hent om 30 min";
	}

	// Too close to closing → defer to next open day
	return getNextAvailablePickupMessage(store, now);
}

export function todaysClosingTime(store: DealerStore, now: Date = new Date()) {
	const todayHours = getOpeningHoursForDate(store, now);
	if (!todayHours) {
		// sunday
		//get opening hours monday
		const { hours: openHour, minutes: openMin } = parseTimeString(store.openingHours.weekDays.openingTime);
		return `Åpner mandag kl. ${openHour}:${openMin}`;
	}
	const { hours: closeHour } = parseTimeString(todayHours.closingTime);
	return `Åpent til kl. ${closeHour}`;
}
